export default __webpack_public_path__ + "static/media/reputation-concurrents.9b9e44bc.svg";